export default "__VITE_ASSET__148e305e__"